export const HSRRatings = [
  {
    id: 1,
    name: 'Acheron',
    slug: 'acheron',
    cat: 'DPS',
    moc_rating: 10,
    pure_rating: 9,
    apo_rating: 10,
    moc_special_rating: 10,
    pure_special_rating: 9,
    apo_special_rating: 10,
    tags: 'Debuff, Partner',
    default: true,
    rarity: 5,
    element: 'Lightning',
    path: 'Nihility'
  },
  {
    id: 70,
    name: 'Anaxa',
    slug: 'anaxa',
    cat: 'Specialist',
    moc_rating: 10,
    pure_rating: 9,
    apo_rating: 11,
    moc_special_rating: 10,
    pure_special_rating: 9,
    apo_special_rating: 11,
    tags: 'Debuff',
    default: true,
    rarity: 5,
    element: 'Wind',
    path: 'Erudition'
  },
  {
    id: 71,
    name: 'Anaxa',
    slug: 'anaxa',
    cat: 'DPS',
    moc_rating: 10,
    pure_rating: 9,
    apo_rating: 11,
    moc_special_rating: 10,
    pure_special_rating: 9,
    apo_special_rating: 11,
    tags: 'Debuff',
    default: false,
    rarity: 5,
    element: 'Wind',
    path: 'Erudition'
  },
  {
    id: 2,
    name: 'Aglaea',
    slug: 'aglaea',
    cat: 'DPS',
    moc_rating: 11,
    pure_rating: 9,
    apo_rating: 10,
    moc_special_rating: 11,
    pure_special_rating: 9,
    apo_special_rating: 10,
    tags: 'Advance, Partner, SP-Friendly, Summon',
    default: true,
    rarity: 5,
    element: 'Lightning',
    path: 'Remembrance'
  },
  {
    id: 3,
    name: 'Argenti',
    slug: 'argenti',
    cat: 'Specialist',
    moc_rating: 10,
    pure_rating: 10,
    apo_rating: 9,
    moc_special_rating: 10,
    pure_special_rating: 10,
    apo_special_rating: 9,
    tags: 'Partner',
    default: true,
    rarity: 5,
    element: 'Physical',
    path: 'Erudition'
  },
  {
    id: 66,
    name: 'Argenti',
    slug: 'argenti',
    cat: 'DPS',
    moc_rating: 7,
    pure_rating: 10,
    apo_rating: 8,
    moc_special_rating: 7,
    pure_special_rating: 10,
    apo_special_rating: 8,
    tags: '',
    default: false,
    rarity: 5,
    element: 'Physical',
    path: 'Erudition'
  },
  {
    id: 4,
    name: 'Arlan',
    slug: 'arlan',
    cat: 'DPS',
    moc_rating: 4,
    pure_rating: 4,
    apo_rating: 4,
    moc_special_rating: 4,
    pure_special_rating: 4,
    apo_special_rating: 4,
    tags: '',
    default: true,
    rarity: 4,
    element: 'Lightning',
    path: 'Destruction'
  },
  {
    id: 5,
    name: 'Asta',
    slug: 'asta',
    cat: 'Amplifier',
    moc_rating: 6,
    pure_rating: 5,
    apo_rating: 7,
    moc_special_rating: 5,
    pure_special_rating: 4,
    apo_special_rating: 6,
    tags: 'Buff',
    default: true,
    rarity: 4,
    element: 'Fire',
    path: 'Harmony'
  },
  {
    id: 6,
    name: 'Aventurine',
    slug: 'aventurine',
    cat: 'Sustain',
    moc_rating: 11,
    pure_rating: 10,
    apo_rating: 11,
    moc_special_rating: 11,
    pure_special_rating: 10,
    apo_special_rating: 11,
    tags: 'Debuff, FUA, SP-Friendly',
    default: true,
    rarity: 5,
    element: 'Imaginary',
    path: 'Preservation'
  },
  {
    id: 7,
    name: 'Bailu',
    slug: 'bailu',
    cat: 'Sustain',
    moc_rating: 7,
    pure_rating: 5,
    apo_rating: 7,
    moc_special_rating: 7,
    pure_special_rating: 5,
    apo_special_rating: 7,
    tags: '',
    default: true,
    rarity: 5,
    element: 'Lightning',
    path: 'Abundance'
  },
  {
    id: 8,
    name: 'Black Swan',
    slug: 'black-swan',
    cat: 'Specialist',
    moc_rating: 8,
    pure_rating: 7,
    apo_rating: 7,
    moc_special_rating: 8,
    pure_special_rating: 7,
    apo_special_rating: 7,
    tags: 'Debuff, DOT',
    default: true,
    rarity: 5,
    element: 'Wind',
    path: 'Nihility'
  },
  {
    id: 9,
    name: 'Blade',
    slug: 'blade',
    cat: 'DPS',
    moc_rating: 7,
    pure_rating: 7,
    apo_rating: 7,
    moc_special_rating: 7,
    pure_special_rating: 7,
    apo_special_rating: 7,
    tags: 'SP-Friendly',
    default: true,
    rarity: 5,
    element: 'Wind',
    path: 'Destruction'
  },
  {
    id: 10,
    name: 'Boothill',
    slug: 'boothill',
    cat: 'DPS',
    moc_rating: 9,
    pure_rating: 4,
    apo_rating: 10,
    moc_special_rating: 9,
    pure_special_rating: 4,
    apo_special_rating: 10,
    tags: 'Break',
    default: true,
    rarity: 5,
    element: 'Physical',
    path: 'Hunt'
  },
  {
    id: 11,
    name: 'Bronya',
    slug: 'bronya',
    cat: 'Amplifier',
    moc_rating: 8,
    pure_rating: 7,
    apo_rating: 9,
    moc_special_rating: 8,
    pure_special_rating: 7,
    apo_special_rating: 9,
    tags: 'Advance, Buff, SP-Unfriendly',
    default: true,
    rarity: 5,
    element: 'Wind',
    path: 'Harmony'
  },
  {
    id: 69,
    name: 'Castorice',
    slug: 'castorice',
    cat: 'DPS',
    moc_rating: 11,
    pure_rating: 10,
    apo_rating: 11,
    moc_special_rating: 11,
    pure_special_rating: 10,
    apo_special_rating: 11,
    tags: 'Advance, SP-Friendly, Summon',
    default: true,
    rarity: 5,
    element: 'Quantum',
    path: 'Remembrance'
  },
  {
    id: 12,
    name: 'Clara',
    slug: 'clara',
    cat: 'DPS',
    moc_rating: 7,
    pure_rating: 6,
    apo_rating: 6,
    moc_special_rating: 7,
    pure_special_rating: 6,
    apo_special_rating: 6,
    tags: 'FUA',
    default: true,
    rarity: 5,
    element: 'Physical',
    path: 'Destruction'
  },
  {
    id: 13,
    name: 'Dan Heng',
    slug: 'dan-heng',
    cat: 'DPS',
    moc_rating: 4,
    pure_rating: 4,
    apo_rating: 4,
    moc_special_rating: 4,
    pure_special_rating: 4,
    apo_special_rating: 4,
    tags: 'Advance, Debuff',
    default: true,
    rarity: 4,
    element: 'Wind',
    path: 'Hunt'
  },
  {
    id: 14,
    name: 'Dr. Ratio',
    slug: 'dr-ratio',
    cat: 'DPS',
    moc_rating: 8,
    pure_rating: 4,
    apo_rating: 6,
    moc_special_rating: 8,
    pure_special_rating: 4,
    apo_special_rating: 6,
    tags: 'Debuff, FUA',
    default: true,
    rarity: 5,
    element: 'Imaginary',
    path: 'Hunt'
  },
  {
    id: 15,
    name: 'Feixiao',
    slug: 'feixiao',
    cat: 'DPS',
    moc_rating: 9,
    pure_rating: 6,
    apo_rating: 11,
    moc_special_rating: 9,
    pure_special_rating: 6,
    apo_special_rating: 11,
    tags: 'FUA, Partner',
    default: true,
    rarity: 5,
    element: 'Wind',
    path: 'Hunt'
  },
  {
    id: 16,
    name: 'Firefly',
    slug: 'firefly',
    cat: 'DPS',
    moc_rating: 9,
    pure_rating: 6,
    apo_rating: 10,
    moc_special_rating: 9,
    pure_special_rating: 6,
    apo_special_rating: 10,
    tags: 'Advance, Break, Partner, SP-Unfriendly',
    default: true,
    rarity: 5,
    element: 'Fire',
    path: 'Destruction'
  },
  {
    id: 17,
    name: 'Fu Xuan',
    slug: 'fu-xuan',
    cat: 'Sustain',
    moc_rating: 9,
    pure_rating: 9,
    apo_rating: 9,
    moc_special_rating: 9,
    pure_special_rating: 9,
    apo_special_rating: 9,
    tags: 'Buff',
    default: true,
    rarity: 5,
    element: 'Quantum',
    path: 'Preservation'
  },
  {
    id: 18,
    name: 'Gallagher',
    slug: 'gallagher',
    cat: 'Sustain',
    moc_rating: 10,
    pure_rating: 9,
    apo_rating: 10,
    moc_special_rating: 9,
    pure_special_rating: 8,
    apo_special_rating: 9,
    tags: 'Advance, Break, Debuff, SP-Friendly',
    default: true,
    rarity: 4,
    element: 'Fire',
    path: 'Abundance'
  },
  {
    id: 19,
    name: 'Gepard',
    slug: 'gepard',
    cat: 'Sustain',
    moc_rating: 6,
    pure_rating: 6,
    apo_rating: 7,
    moc_special_rating: 6,
    pure_special_rating: 6,
    apo_special_rating: 7,
    tags: '',
    default: true,
    rarity: 5,
    element: 'Ice',
    path: 'Preservation'
  },
  {
    id: 20,
    name: 'Guinaifen',
    slug: 'guinaifen',
    cat: 'Amplifier',
    moc_rating: 6,
    pure_rating: 5,
    apo_rating: 6,
    moc_special_rating: 6,
    pure_special_rating: 5,
    apo_special_rating: 6,
    tags: 'Debuff, DOT',
    default: true,
    rarity: 4,
    element: 'Fire',
    path: 'Nihility'
  },
  {
    id: 21,
    name: 'Hanya',
    slug: 'hanya',
    cat: 'Amplifier',
    moc_rating: 5,
    pure_rating: 4,
    apo_rating: 5,
    moc_special_rating: 4,
    pure_special_rating: 4,
    apo_special_rating: 4,
    tags: 'Buff',
    default: true,
    rarity: 4,
    element: 'Physical',
    path: 'Harmony'
  },
  {
    id: 22,
    name: 'Herta',
    slug: 'herta',
    cat: 'Specialist',
    moc_rating: 9,
    pure_rating: 10,
    apo_rating: 9,
    moc_special_rating: 9,
    pure_special_rating: 10,
    apo_special_rating: 9,
    tags: 'FUA',
    default: true,
    rarity: 4,
    element: 'Ice',
    path: 'Erudition'
  },
  {
    id: 23,
    name: 'Himeko',
    slug: 'himeko',
    cat: 'DPS',
    moc_rating: 7,
    pure_rating: 8,
    apo_rating: 8,
    moc_special_rating: 7,
    pure_special_rating: 8,
    apo_special_rating: 8,
    tags: 'FUA',
    default: true,
    rarity: 5,
    element: 'Fire',
    path: 'Erudition'
  },
  {
    id: 24,
    name: 'Hook',
    slug: 'hook',
    cat: 'DPS',
    moc_rating: 4,
    pure_rating: 4,
    apo_rating: 4,
    moc_special_rating: 4,
    pure_special_rating: 4,
    apo_special_rating: 4,
    tags: '',
    default: true,
    rarity: 4,
    element: 'Fire',
    path: 'Destruction'
  },
  {
    id: 25,
    name: 'Huohuo',
    slug: 'huohuo',
    cat: 'Sustain',
    moc_rating: 11,
    pure_rating: 10,
    apo_rating: 9,
    moc_special_rating: 11,
    pure_special_rating: 10,
    apo_special_rating: 9,
    tags: 'Buff, Energy',
    default: true,
    rarity: 5,
    element: 'Wind',
    path: 'Abundance'
  },
  {
    id: 26,
    name: 'Imbibitor Lunae',
    slug: 'imbibitor-lunae',
    cat: 'DPS',
    moc_rating: 8,
    pure_rating: 5,
    apo_rating: 6,
    moc_special_rating: 8,
    pure_special_rating: 5,
    apo_special_rating: 6,
    tags: 'SP-Unfriendly',
    default: true,
    rarity: 5,
    element: 'Imaginary',
    path: 'Destruction'
  },
  {
    id: 27,
    name: 'Jade',
    slug: 'jade',
    cat: 'Specialist',
    moc_rating: 10,
    pure_rating: 11,
    apo_rating: 10,
    moc_special_rating: 10,
    pure_special_rating: 11,
    apo_special_rating: 10,
    tags: 'FUA, SP-Friendly',
    default: true,
    rarity: 5,
    element: 'Quantum',
    path: 'Erudition'
  },
  {
    id: 28,
    name: 'Jiaoqiu',
    slug: 'jiaoqiu',
    cat: 'Amplifier',
    moc_rating: 10,
    pure_rating: 9,
    apo_rating: 10,
    moc_special_rating: 10,
    pure_special_rating: 9,
    apo_special_rating: 10,
    tags: 'Debuff, DOT, Partner',
    default: true,
    rarity: 5,
    element: 'Fire',
    path: 'Nihility'
  },
  {
    id: 29,
    name: 'Jing Yuan',
    slug: 'jing-yuan',
    cat: 'DPS',
    moc_rating: 9,
    pure_rating: 9,
    apo_rating: 9,
    moc_special_rating: 9,
    pure_special_rating: 9,
    apo_special_rating: 9,
    tags: 'FUA, Partner, Summon',
    default: true,
    rarity: 5,
    element: 'Lightning',
    path: 'Erudition'
  },
  {
    id: 30,
    name: 'Jingliu',
    slug: 'jingliu',
    cat: 'DPS',
    moc_rating: 7,
    pure_rating: 5,
    apo_rating: 6,
    moc_special_rating: 7,
    pure_special_rating: 5,
    apo_special_rating: 6,
    tags: 'SP-Friendly',
    default: true,
    rarity: 5,
    element: 'Ice',
    path: 'Destruction'
  },
  {
    id: 31,
    name: 'Kafka',
    slug: 'kafka',
    cat: 'DPS',
    moc_rating: 7,
    pure_rating: 7,
    apo_rating: 7,
    moc_special_rating: 7,
    pure_special_rating: 7,
    apo_special_rating: 7,
    tags: 'DOT',
    default: true,
    rarity: 5,
    element: 'Lightning',
    path: 'Nihility'
  },
  {
    id: 32,
    name: 'Lingsha',
    slug: 'lingsha',
    cat: 'Sustain',
    moc_rating: 11,
    pure_rating: 11,
    apo_rating: 11,
    moc_special_rating: 11,
    pure_special_rating: 11,
    apo_special_rating: 11,
    tags: 'Break, Debuff, FUA, Summon',
    default: true,
    rarity: 5,
    element: 'Fire',
    path: 'Abundance'
  },
  {
    id: 33,
    name: 'Luka',
    slug: 'luka',
    cat: 'DPS',
    moc_rating: 5,
    pure_rating: 4,
    apo_rating: 4,
    moc_special_rating: 4,
    pure_special_rating: 4,
    apo_special_rating: 4,
    tags: 'Break, Debuff',
    default: true,
    rarity: 4,
    element: 'Physical',
    path: 'Nihility'
  },
  {
    id: 34,
    name: 'Luocha',
    slug: 'luocha',
    cat: 'Sustain',
    moc_rating: 9,
    pure_rating: 9,
    apo_rating: 9,
    moc_special_rating: 9,
    pure_special_rating: 9,
    apo_special_rating: 9,
    tags: 'SP-Friendly',
    default: true,
    rarity: 5,
    element: 'Imaginary',
    path: 'Abundance'
  },
  {
    id: 35,
    name: 'Lynx',
    slug: 'lynx',
    cat: 'Sustain',
    moc_rating: 6,
    pure_rating: 5,
    apo_rating: 6,
    moc_special_rating: 5,
    pure_special_rating: 4,
    apo_special_rating: 5,
    tags: '',
    default: true,
    rarity: 4,
    element: 'Quantum',
    path: 'Abundance'
  },
  {
    id: 36,
    name: 'March 7th',
    slug: 'march-7th',
    cat: 'Sustain',
    moc_rating: 4,
    pure_rating: 4,
    apo_rating: 4,
    moc_special_rating: 4,
    pure_special_rating: 4,
    apo_special_rating: 4,
    tags: '',
    default: true,
    rarity: 4,
    element: 'Ice',
    path: 'Preservation'
  },
  {
    id: 37,
    name: 'March 7th - The Hunt',
    slug: 'march-7th-swordmaster',
    cat: 'Specialist',
    moc_rating: 9,
    pure_rating: 5,
    apo_rating: 10,
    moc_special_rating: 9,
    pure_special_rating: 5,
    apo_special_rating: 10,
    tags: 'Advance, Break, Buff, FUA',
    default: true,
    rarity: 4,
    element: 'Imaginary',
    path: 'Hunt'
  },
  {
    id: 38,
    name: 'Misha',
    slug: 'misha',
    cat: 'DPS',
    moc_rating: 4,
    pure_rating: 4,
    apo_rating: 4,
    moc_special_rating: 4,
    pure_special_rating: 4,
    apo_special_rating: 4,
    tags: 'Debuff',
    default: true,
    rarity: 4,
    element: 'Ice',
    path: 'Destruction'
  },
  {
    id: 39,
    name: 'Moze',
    slug: 'moze',
    cat: 'Specialist',
    moc_rating: 8,
    pure_rating: 4,
    apo_rating: 8,
    moc_special_rating: 7,
    pure_special_rating: 4,
    apo_special_rating: 7,
    tags: 'Debuff, FUA',
    default: true,
    rarity: 4,
    element: 'Lightning',
    path: 'Hunt'
  },
  {
    id: 68,
    name: 'Mydei',
    slug: 'mydei',
    cat: 'DPS',
    moc_rating: 11,
    pure_rating: 7,
    apo_rating: 10,
    moc_special_rating: 11,
    pure_special_rating: 7,
    apo_special_rating: 10,
    tags: 'Advance, SP-Friendly',
    default: true,
    rarity: 5,
    element: 'Imaginary',
    path: 'Destruction'
  },
  {
    id: 40,
    name: 'Natasha',
    slug: 'natasha',
    cat: 'Sustain',
    moc_rating: 4,
    pure_rating: 4,
    apo_rating: 4,
    moc_special_rating: 4,
    pure_special_rating: 4,
    apo_special_rating: 4,
    tags: '',
    default: true,
    rarity: 4,
    element: 'Physical',
    path: 'Abundance'
  },
  {
    id: 41,
    name: 'Pela',
    slug: 'pela',
    cat: 'Amplifier',
    moc_rating: 9,
    pure_rating: 8,
    apo_rating: 9,
    moc_special_rating: 9,
    pure_special_rating: 8,
    apo_special_rating: 9,
    tags: 'Debuff',
    default: true,
    rarity: 4,
    element: 'Ice',
    path: 'Nihility'
  },
  {
    id: 42,
    name: 'Qingque',
    slug: 'qingque',
    cat: 'DPS',
    moc_rating: 6,
    pure_rating: 5,
    apo_rating: 5,
    moc_special_rating: 5,
    pure_special_rating: 4,
    apo_special_rating: 4,
    tags: 'SP-Unfriendly',
    default: true,
    rarity: 4,
    element: 'Quantum',
    path: 'Erudition'
  },
  {
    id: 43,
    name: 'Rappa',
    slug: 'rappa',
    cat: 'DPS',
    moc_rating: 10,
    pure_rating: 10,
    apo_rating: 10,
    moc_special_rating: 10,
    pure_special_rating: 10,
    apo_special_rating: 10,
    tags: 'Advance, Break, Partner, SP-Friendly',
    default: true,
    rarity: 5,
    element: 'Imaginary',
    path: 'Erudition'
  },
  {
    id: 44,
    name: 'Robin',
    slug: 'robin',
    cat: 'Amplifier',
    moc_rating: 11,
    pure_rating: 11,
    apo_rating: 11,
    moc_special_rating: 11,
    pure_special_rating: 11,
    apo_special_rating: 11,
    tags: 'Advance, Buff, FUA',
    default: true,
    rarity: 5,
    element: 'Physical',
    path: 'Harmony'
  },
  {
    id: 45,
    name: 'Ruan Mei',
    slug: 'ruan-mei',
    cat: 'Amplifier',
    moc_rating: 10,
    pure_rating: 10,
    apo_rating: 11,
    moc_special_rating: 10,
    pure_special_rating: 10,
    apo_special_rating: 11,
    tags: 'Break, Buff, Delay',
    default: true,
    rarity: 5,
    element: 'Ice',
    path: 'Harmony'
  },
  {
    id: 46,
    name: 'Sampo',
    slug: 'sampo',
    cat: 'Specialist',
    moc_rating: 5,
    pure_rating: 4,
    apo_rating: 5,
    moc_special_rating: 4,
    pure_special_rating: 4,
    apo_special_rating: 4,
    tags: 'Break, Debuff, DOT',
    default: true,
    rarity: 4,
    element: 'Wind',
    path: 'Nihility'
  },
  {
    id: 47,
    name: 'Seele',
    slug: 'seele',
    cat: 'DPS',
    moc_rating: 6,
    pure_rating: 5,
    apo_rating: 7,
    moc_special_rating: 6,
    pure_special_rating: 5,
    apo_special_rating: 7,
    tags: 'Advance',
    default: true,
    rarity: 5,
    element: 'Quantum',
    path: 'Hunt'
  },
  {
    id: 48,
    name: 'Serval',
    slug: 'serval',
    cat: 'Specialist',
    moc_rating: 9,
    pure_rating: 9,
    apo_rating: 9,
    moc_special_rating: 8,
    pure_special_rating: 8,
    apo_special_rating: 8,
    tags: 'DOT, Partner',
    default: true,
    rarity: 4,
    element: 'Lightning',
    path: 'Erudition'
  },
  {
    id: 49,
    name: 'Silver Wolf',
    slug: 'silver-wolf',
    cat: 'Amplifier',
    moc_rating: 7,
    pure_rating: 4,
    apo_rating: 8,
    moc_special_rating: 7,
    pure_special_rating: 4,
    apo_special_rating: 8,
    tags: 'Break, Debuff',
    default: true,
    rarity: 5,
    element: 'Quantum',
    path: 'Nihility'
  },
  {
    id: 50,
    name: 'Sparkle',
    slug: 'sparkle',
    cat: 'Amplifier',
    moc_rating: 9,
    pure_rating: 8,
    apo_rating: 9,
    moc_special_rating: 9,
    pure_special_rating: 8,
    apo_special_rating: 9,
    tags: 'Advance, Buff, SP-Friendly',
    default: true,
    rarity: 5,
    element: 'Quantum',
    path: 'Harmony'
  },
  {
    id: 51,
    name: 'Sunday',
    slug: 'sunday',
    cat: 'Amplifier',
    moc_rating: 11,
    pure_rating: 11,
    apo_rating: 10,
    moc_special_rating: 11,
    pure_special_rating: 11,
    apo_special_rating: 10,
    tags: 'Advance, Buff, Energy, Summon',
    default: true,
    rarity: 5,
    element: 'Imaginary',
    path: 'Harmony'
  },
  {
    id: 52,
    name: 'Sushang',
    slug: 'sushang',
    cat: 'DPS',
    moc_rating: 4,
    pure_rating: 4,
    apo_rating: 5,
    moc_special_rating: 4,
    pure_special_rating: 4,
    apo_special_rating: 4,
    tags: 'Advance, Break',
    default: true,
    rarity: 4,
    element: 'Physical',
    path: 'Hunt'
  },
  {
    id: 53,
    name: 'The Herta',
    slug: 'the-herta',
    cat: 'DPS',
    moc_rating: 11,
    pure_rating: 11,
    apo_rating: 11,
    moc_special_rating: 11,
    pure_special_rating: 11,
    apo_special_rating: 11,
    tags: 'Advance, SP-Unfriendly',
    default: true,
    rarity: 5,
    element: 'Ice',
    path: 'Erudition'
  },
  {
    id: 54,
    name: 'Tingyun',
    slug: 'tingyun',
    cat: 'Amplifier',
    moc_rating: 8,
    pure_rating: 8,
    apo_rating: 8,
    moc_special_rating: 7,
    pure_special_rating: 7,
    apo_special_rating: 7,
    tags: 'Buff, Energy',
    default: true,
    rarity: 4,
    element: 'Lightning',
    path: 'Harmony'
  },
  {
    id: 55,
    name: 'Fugue',
    slug: 'tingyun-fugue',
    cat: 'Amplifier',
    moc_rating: 10,
    pure_rating: 10,
    apo_rating: 10,
    moc_special_rating: 10,
    pure_special_rating: 10,
    apo_special_rating: 10,
    tags: 'Break, Buff, Debuff, Delay',
    default: true,
    rarity: 5,
    element: 'Fire',
    path: 'Nihility'
  },
  {
    id: 56,
    name: 'Topaz & Numby',
    slug: 'topaz',
    cat: 'Specialist',
    moc_rating: 9,
    pure_rating: 5,
    apo_rating: 9,
    moc_special_rating: 9,
    pure_special_rating: 5,
    apo_special_rating: 9,
    tags: 'Debuff, FUA, Summon',
    default: true,
    rarity: 5,
    element: 'Fire',
    path: 'Hunt'
  },
  {
    id: 57,
    name: 'Trailblazer - Destruction',
    slug: 'trailblazer-destruction',
    cat: 'DPS',
    moc_rating: 4,
    pure_rating: 4,
    apo_rating: 4,
    moc_special_rating: 4,
    pure_special_rating: 4,
    apo_special_rating: 4,
    tags: '',
    default: true,
    rarity: 5,
    element: 'Physical',
    path: 'Destruction'
  },
  {
    id: 58,
    name: 'Trailblazer - Harmony',
    slug: 'trailblazer-harmony',
    cat: 'Amplifier',
    moc_rating: 9,
    pure_rating: 8,
    apo_rating: 9,
    moc_special_rating: 9,
    pure_special_rating: 8,
    apo_special_rating: 9,
    tags: 'Break, Buff',
    default: true,
    rarity: 5,
    element: 'Imaginary',
    path: 'Harmony'
  },
  {
    id: 59,
    name: 'Trailblazer - Preservation',
    slug: 'trailblazer-preservation',
    cat: 'Sustain',
    moc_rating: 4,
    pure_rating: 4,
    apo_rating: 4,
    moc_special_rating: 4,
    pure_special_rating: 4,
    apo_special_rating: 4,
    tags: 'Break, Debuff',
    default: true,
    rarity: 5,
    element: 'Fire',
    path: 'Preservation'
  },
  {
    id: 60,
    name: 'Trailblazer - Remembrance',
    slug: 'trailblazer-remembrance',
    cat: 'Amplifier',
    moc_rating: 11,
    pure_rating: 11,
    apo_rating: 11,
    moc_special_rating: 11,
    pure_special_rating: 11,
    apo_special_rating: 11,
    tags: 'Advance, Buff, Summon',
    default: true,
    rarity: 5,
    element: 'Ice',
    path: 'Remembrance'
  },
  {
    id: 67,
    name: 'Tribbie',
    slug: 'tribbie',
    cat: 'Specialist',
    moc_rating: 11,
    pure_rating: 11,
    apo_rating: 11,
    moc_special_rating: 11,
    pure_special_rating: 11,
    apo_special_rating: 11,
    tags: 'Buff, FUA',
    default: true,
    rarity: 5,
    element: 'Quantum',
    path: 'Harmony'
  },
  {
    id: 61,
    name: 'Welt',
    slug: 'welt',
    cat: 'Specialist',
    moc_rating: 5,
    pure_rating: 5,
    apo_rating: 5,
    moc_special_rating: 5,
    pure_special_rating: 5,
    apo_special_rating: 5,
    tags: 'Debuff, Delay',
    default: true,
    rarity: 5,
    element: 'Imaginary',
    path: 'Nihility'
  },
  {
    id: 62,
    name: 'Xueyi',
    slug: 'xueyi',
    cat: 'DPS',
    moc_rating: 5,
    pure_rating: 5,
    apo_rating: 5,
    moc_special_rating: 4,
    pure_special_rating: 4,
    apo_special_rating: 4,
    tags: 'Break, FUA',
    default: true,
    rarity: 4,
    element: 'Quantum',
    path: 'Destruction'
  },
  {
    id: 63,
    name: 'Yanqing',
    slug: 'yanqing',
    cat: 'DPS',
    moc_rating: 4,
    pure_rating: 4,
    apo_rating: 4,
    moc_special_rating: 4,
    pure_special_rating: 4,
    apo_special_rating: 4,
    tags: '',
    default: true,
    rarity: 5,
    element: 'Ice',
    path: 'Hunt'
  },
  {
    id: 64,
    name: 'Yukong',
    slug: 'yukong',
    cat: 'Amplifier',
    moc_rating: 4,
    pure_rating: 4,
    apo_rating: 4,
    moc_special_rating: 4,
    pure_special_rating: 4,
    apo_special_rating: 4,
    tags: 'Buff',
    default: true,
    rarity: 4,
    element: 'Imaginary',
    path: 'Harmony'
  },
  {
    id: 65,
    name: 'Yunli',
    slug: 'yunli',
    cat: 'DPS',
    moc_rating: 9,
    pure_rating: 8,
    apo_rating: 8,
    moc_special_rating: 9,
    pure_special_rating: 8,
    apo_special_rating: 8,
    tags: 'FUA',
    default: true,
    rarity: 5,
    element: 'Physical',
    path: 'Destruction'
  }
];
